var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneRoundedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00A3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 25C19.5224 25 19 25.5224 19 26.1667C19 26.8111 19.5224 27.3335 20.1667 27.3335C20.8111 27.3335 21.3335 26.8111 21.3335 26.1667C21.3335 25.5224 20.8111 25 20.1667 25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 10.8333C13.3333 10.3731 13.7063 10 14.1666 10H25.8333C26.2935 10 26.6666 10.3731 26.6666 10.8333V29.1667C26.6666 29.6269 26.2935 30 25.8333 30H14.1666C13.7063 30 13.3333 29.6269 13.3333 29.1667V10.8333ZM14.8333 28.5V11.5H25.1666V28.5H14.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRoundedBlue);
export default __webpack_public_path__ + "static/media/phone-rounded-blue.f4a15355cb2b1544344347d94b15da10.svg";
export { ForwardRef as ReactComponent };